import {
    GAME_COMMAND,
    OPEN_LINK,
    OPEN_NEWS_ARTICLE,
} from "../constants/types/commands";

type OpenLinkPayload = {
    url: string;
    id?: string;
    label?: string;
};

export const mutateOpenLinkHack =
    (protocol: string) => (payload: OpenLinkPayload) => {
        const protocolWithoutInbox = protocol.replace("-inbox", "");

        if (payload.url.indexOf(protocol) === 0) {
            return { type: GAME_COMMAND, payload };
        }

        if (payload.url.indexOf(protocolWithoutInbox) === 0) {
            return {
                type: GAME_COMMAND,
                payload: {
                    ...payload,
                    // We add the -inbox to the protocol to make it work from within the Inbox
                    url: payload.url.replace("://", "-inbox://"),
                },
            };
        }

        if (payload.url.indexOf(location.origin) > -1) {
            const newsIndex = payload.url.indexOf("/news/");

            if (newsIndex > -1) {
                const match = /#\/(?<lang>.*)\/news/.exec(payload.url);
                const lang = match?.groups?.lang ?? "en";
                const params = payload.url.substr(
                    newsIndex + "news/".length + 1,
                );
                const [id, slug] = params.split("/");

                return {
                    type: OPEN_NEWS_ARTICLE,
                    payload: {
                        lang,
                        id,
                        slug,
                    },
                };
            }
        }

        return {
            type: OPEN_LINK,
            payload,
        };
    };
